import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from './CheckoutErrorDialog.module.css'

interface ButtonData { text: string, onClick: () => void }

interface CheckoutErrorDialogProps { buttonData?: ButtonData, textId?: string, supportingTextId?: string }

export function CheckoutErrorDialog({ buttonData, textId = 'checkout_steps_error_title_text', supportingTextId = 'checkout_steps_error_description_text' }: CheckoutErrorDialogProps) {
  const intl = useIntl()

  return (
    <div className={styles.checkoutErrorDialogWrapper}>
      <Dialog
        text={intl.formatMessage({ id: textId })}
        supportingText={intl.formatMessage({ id: supportingTextId })}
        type="alert"
        actionsSlot={buttonData && (
          <Button variant="primary" onClick={buttonData.onClick} className={styles.checkoutErrorDialogButton}>
            {buttonData.text}
          </Button>
        )}
      />
    </div>
  )
}
